/*
 * Nursem hero slideshow.
 * Drives the scroll-snap carousel in sections/nursem-hero-slideshow.liquid:
 * autoplay, prev/next arrows, pagination dots, active-state tracking.
 * Pauses on hover / drag / focus / hidden tab and respects reduced-motion.
 */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(root) {
    if (root.__nursemHeroInit) return;
    root.__nursemHeroInit = true;

    var track = root.querySelector('.nursem-hero__track');
    if (!track) return;
    var slides = Array.prototype.slice.call(
      track.querySelectorAll('.nursem-hero__slide')
    );
    if (slides.length <= 1) return; // nothing to rotate

    var wantArrows = root.getAttribute('data-arrows') === 'true';
    var wantDots = root.getAttribute('data-dots') === 'true';
    var wantAutoplay =
      root.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;

    var current = 0;

    function goTo(index, smooth) {
      var count = slides.length;
      index = ((index % count) + count) % count; // wrap both directions
      track.scrollTo({
        left: index * track.clientWidth,
        behavior: smooth === false || reduceMotion ? 'auto' : 'smooth'
      });
    }

    // ── Arrows ──
    if (wantArrows) {
      var prev = root.querySelector('.nursem-hero__arrow--prev');
      var next = root.querySelector('.nursem-hero__arrow--next');
      if (prev) {
        prev.hidden = false;
        prev.addEventListener('click', function () {
          goTo(current - 1);
          bumpAutoplay();
        });
      }
      if (next) {
        next.hidden = false;
        next.addEventListener('click', function () {
          goTo(current + 1);
          bumpAutoplay();
        });
      }
    }

    // ── Dots ──
    var dots = [];
    if (wantDots) {
      var dotsEl = root.querySelector('.nursem-hero__dots');
      if (dotsEl) {
        dotsEl.innerHTML = '';
        slides.forEach(function (_slide, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'nursem-hero__dot';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.addEventListener('click', function () {
            goTo(i);
            bumpAutoplay();
          });
          dotsEl.appendChild(b);
          dots.push(b);
        });
      }
    }

    function setActive(index) {
      current = index;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
        dots[i].setAttribute('aria-selected', i === index ? 'true' : 'false');
      }
    }
    setActive(0);

    // ── Track active slide from scroll position ──
    var raf;
    track.addEventListener(
      'scroll',
      function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = null;
          if (!track.clientWidth) return;
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          if (idx !== current) setActive(idx);
        });
      },
      { passive: true }
    );

    // ── Autoplay (pause on interaction / hidden tab) ──
    var timer = null;
    function startAutoplay() {
      if (!wantAutoplay || timer) return;
      timer = window.setInterval(function () {
        goTo(current + 1);
      }, interval);
    }
    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }
    // Restart the clock so a manual change gets a full dwell before auto-advance.
    function bumpAutoplay() {
      if (!wantAutoplay) return;
      stopAutoplay();
      startAutoplay();
    }

    root.addEventListener('pointerenter', stopAutoplay);
    root.addEventListener('pointerleave', startAutoplay);
    root.addEventListener('pointerdown', stopAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    // Keep the active slide in place across viewport resizes (clientWidth changes).
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        goTo(current, false);
      }, 150);
    });

    startAutoplay();
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('.nursem-hero')
      .forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target;
    if (!el) return;
    if (el.matches && el.matches('.nursem-hero')) initHero(el);
    initAll(el);
  });
})();
